import { render, staticRenderFns } from "./BigInfo.vue?vue&type=template&id=29c93180&"
import script from "./BigInfo.vue?vue&type=script&lang=js&"
export * from "./BigInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports